import type {
  AddFriendResponse,
  FriendDetailResponse,
  FriendsResponse,
  UserLookupResponse,
} from "@qota/shared";
import { request } from "./http";

export function getFriends(): Promise<FriendsResponse> {
  return request<FriendsResponse>("GET", "/friends");
}

export function getFriend(
  key: string,
  params: { before?: string; limit?: number } = {},
): Promise<FriendDetailResponse> {
  const query = new URLSearchParams();
  if (params.before) query.set("before", params.before);
  if (params.limit) query.set("limit", String(params.limit));

  const suffix = query.size > 0 ? `?${query.toString()}` : "";
  // La chiave contiene i due punti: senza codifica finirebbe spezzata nel path.
  return request<FriendDetailResponse>("GET", `/friends/${encodeURIComponent(key)}${suffix}`);
}

export function addFriend(nickname: string): Promise<AddFriendResponse> {
  return request<AddFriendResponse>("POST", "/friends", { nickname });
}

export function findUserByNickname(nickname: string): Promise<UserLookupResponse> {
  return request<UserLookupResponse>(
    "GET",
    `/users/by-nickname/${encodeURIComponent(nickname)}`,
  );
}
